export default __webpack_public_path__ + "static/honeycomb-light1-82a46f7c2d6dac062a13588aa082c745.png";